import { z } from 'zod';
/**
 * Maximum allowed knownTotal value — prevents unbounded client-supplied totals
 * from being blindly trusted.
 */
export const KNOWN_TOTAL_MAX = 10000000;
/**
 * Shared Zod schema for the `knownTotal` query parameter.
 * Use in all DataTable-style endpoint querystring schemas.
 */
export const knownTotalQuerySchema = z.coerce
    .number()
    .int()
    .min(0)
    .max(KNOWN_TOTAL_MAX)
    .optional();
/**
 * Shared Zod schema for `knownTotal` in internal handler/engine parameters (no coercion).
 * Use in table-engine params and handler interfaces.
 */
export const knownTotalParamsSchema = z
    .number()
    .int()
    .min(0)
    .max(KNOWN_TOTAL_MAX)
    .optional();
//# sourceMappingURL=known-total.js.map